import { classNames } from 'helpers/utilities'
import { ITooltip, Tooltip as ReactTooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

export default function Tooltip({ className = '', ...rest }: ITooltip) {
  return <ReactTooltip className={classNames('rt rt-custom', className)} {...rest} />
}
